import { render, staticRenderFns } from "./newUserModal.vue?vue&type=template&id=f4d93e20&"
import script from "./newUserModal.vue?vue&type=script&lang=js&"
export * from "./newUserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports